import { Control } from "react-hook-form";
import { FormInput } from "../../../../components/ui/Input/FormInput/FormInput";
import { FormSearchSelect } from "../../../../components/ui/Input/FormSearchSelect/FormSearchSelect";
import { FormSelect } from "../../../../components/ui/Input/FormSelector/FormSelect";
import { FormTextarea } from "../../../../components/ui/Input/FormTextArea/FormTextarea";
import { FACILITY_OWNERSHIP, FACILITY_TYPES } from "../../../../config/constants";
import { facilityNameRules } from "../helpers/facilityValidation.helpers";
import { FacilityDraftFormValues } from "../types/facilityDrawer.types";

interface CountryOption {
  id: string;
  title: string;
  value: string;
}

interface FacilityInfoFieldsProps {
  control: Control<FacilityDraftFormValues>;
  countryOptions: CountryOption[];
  isCountriesLoading: boolean;
}

const FacilityInfoFields = ({ control, countryOptions, isCountriesLoading }: FacilityInfoFieldsProps) => (
  <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4">
    <FormInput
      control={control}
      name="facilityName"
      label="Facility Name"
      required
      errorMessage="Facility name is required"
      rules={facilityNameRules}
      placeholder="Facility Name"
    />
    <FormSelect
      control={control}
      name="facilityOwnership"
      label="Facility Ownership"
      required
      errorMessage="Facility ownership is required"
      options={FACILITY_OWNERSHIP}
      placeholder="Select ownership"
    />
    <FormSelect
      control={control}
      name="facilityType"
      label="Facility Type"
      required
      errorMessage="Facility type is required"
      options={FACILITY_TYPES}
      placeholder="Select type"
    />
    <FormSearchSelect
      control={control}
      name="facilityCountry"
      label="Country"
      required
      errorMessage="Facility country is required"
      options={countryOptions}
      loading={isCountriesLoading}
      placeholder="Select country"
    />
    <FormTextarea
      control={control}
      name="facilityAddress"
      label="Address"
      placeholder="Address"
      className="tw-min-h-[76px] tw-resize-y"
    />
    <FormInput control={control} name="facilityCity" label="City" placeholder="City" />
  </div>
);

export default FacilityInfoFields;
